import Component from '@ux/component';
import NavigationHelp from './navigation-help';
import React from 'react';

class Header extends Component {
  render() {
    const props = this.props;

    return (
      <header className='manifest'>
        <div className='nav-top-stroke'>&nbsp;</div>
        <NavigationHelp { ...props } />
      </header>
    );
  }
}

export default Header;
